import { Action, combineReducers, Reducer } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { enableMapSet, setAutoFreeze } from 'immer';

import actionBarReducer from './actionBar';
import authReducer from './auth';
import billingNotificationReducer from './billingRedirect/billingRedirect';
import businessLibraryReducers from './businessLibrary';
import buttonReducer from './button/index';
import calendarReducer from './calendar';
import capitalReducers from './capital';
import confirmActionReducer from './confirm-action';
import confirmEmployeeReducer from './confirmEmployee/index';
import dashboardIndexReducer from './dashboard/index';
import employeeReducer from './employees';
import featureFlagsReducer from './featureFlags';
import unleashFeatureFlagsReducer from './featureFlags/unleash';
import featureRestrictionsReducer from './featureRestrictions';
import ftue from './ftue';
import inventoryReducer from './inventory';
import kybReducers from './kyb';
import libraryReducers from './library';
import loadingSpinnerReducer from './loadingSpinner/index';
import moka from './moka';
import notificationReducer from './notifications';
import openPlatformReducer from './openPlatform';
import outletPageReducer from './outletPages';
import outletReducer from './outlet';
import registerReducers from './register';
import reportsReducer from './reports';
import settingReducer from './setting';
import subscriptionExpiredReducer from './subscriptionExpired/index';
import uploadersReducer from './uploaders/index';
import uploadImageReducer from './uploadImage/index';
import userPropertiesReducer from './userProperties';
import inventoryFeatures from './inventoryFeatures';
import inventorySettingsReducer from './inventorySettings';
import exportingReducer from './exporting';

enableMapSet();
// TODO: we need to fix this eventually...
setAutoFreeze(false);

type ReducersMap = Record<string, Reducer<unknown, Action>>;

const reducerMap: ReducersMap = {
  actionBar: actionBarReducer,
  auth: authReducer, // auth specific reducer
  billingNotification: billingNotificationReducer,
  buttons: buttonReducer,
  businessLibrary: businessLibraryReducers,
  calendar: calendarReducer, // for dropdown calendar
  capital: capitalReducers,
  confirmAction: confirmActionReducer,
  confirmEmployee: confirmEmployeeReducer,
  dashboard: combineReducers({ index: dashboardIndexReducer }),
  employee: employeeReducer,
  featureFlags: featureFlagsReducer,
  unleashFeatureFlags: unleashFeatureFlagsReducer,
  featureRestrictions: featureRestrictionsReducer,
  form: formReducer, // redux form reducer. Please don't change the key name
  ftue,
  inventory: inventoryReducer,
  inventoryFeatures,
  kybForm: kybReducers,
  library: libraryReducers,
  loadingSpinner: loadingSpinnerReducer,
  moka, // moka default reducer. Please don't change the key name,
  notification: notificationReducer, // our custom reducer for notification.
  openPlatform: openPlatformReducer,
  outlet: outletReducer, // outlet for related user
  outletPages: outletPageReducer,
  registerForm: registerReducers,
  reports: reportsReducer,
  routing: routerReducer, // reducer from react-router-redux. Please don't change the key name
  setting: settingReducer,
  subscriptionExpired: subscriptionExpiredReducer,
  uploaders: combineReducers({
    import: uploadersReducer,
  }),
  uploadImage: combineReducers({ uploadImage: uploadImageReducer }),
  userProperties: userPropertiesReducer,
  inventorySettings: inventorySettingsReducer,
  exporting: exportingReducer,
};

const createReducers = (asyncReducers?: ReducersMap) => {
  if (asyncReducers && Object.keys(asyncReducers).length !== 0) {
    return combineReducers({ ...reducerMap, ...asyncReducers });
  }
  return combineReducers({ ...reducerMap });
};

export { createReducers, reducerMap };
